export default {
      id: "191,8_cm_=_70_+_45_+_28,4_+_45-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#191,8_cm_=_70_+_45_+_28,4_+_45",
      toString: function () {
        return this.url;
      }
    }